export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#2B9DD6\"/><g fill=\"#FFF\" fill-rule=\"nonzero\" transform=\"translate(6.5 4.5)\"><circle cx=\"1.262\" cy=\".75\" r=\"1\"/><path d=\"M2 6V3a.5.5 0 00-.5-.5H0v1h1V6H0v1h3V6H2z\"/></g></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};